import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { WithTranslation, withTranslation } from 'react-i18next';

interface ITypeDropDownProps extends WithTranslation{
    handleChanges: any,
    id:string
}
const selectOptions = [
    { key: "Test", text: "Test", value: "test" },
    { key: "Training", text: "Training", value: "training" },
    { key: "Warm-up", text: "Warm-up", value: "warm-up" }
];
const TypeDropDown =(props: ITypeDropDownProps) =>{
    return(<Dropdown
        placeholder={props.t('placeholder.subtype')}
        fluid
        selection
        options={selectOptions}
        onChange={props.handleChanges}
        id={props.id}
  />)
}

export default withTranslation('exerciseCreator') (TypeDropDown);